import { toast } from 'sonner';

import { useAxios } from '@/hooks/useAxios';
import { useMy } from '@/hooks/useMy';
import { useMutation } from '@/utils/api';

export function useRunAffiliation() {
  const axios = useAxios();
  const { data: settings, status: settingsStatus } = useMy({
    resource: 'setting',
  });

  const displayNameSetting = settings?.find(s => s.name === 'display-name');
  const displayName =
    typeof displayNameSetting?.value === 'string'
      ? displayNameSetting.value
      : '';

  const affiliationMutation = useMutation({
    defaultErrorMessage: 'Failed to check affiliation',
    mutationFn: async (key: string) => {
      if (displayName) {
        try {
          const response = await axios.put('/agent', {
            agent: 'affiliation',
            key,
          });
          toast.success(
            'Started asset affiliation check. Results will appear in the History tab.'
          );
          return response.data;
        } catch (error) {
          toast.error('Failed to check affiliation');
          return null;
        }
      }

      toast.error(
        'Organization name must be set for the affiliation agent to run'
      );
      return null;
    },
  });

  return {
    ...affiliationMutation,
    settingsStatus,
  };
}
